import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    CheckLlmCapsRequestRuntype,
    CheckLlmCapsResponseRuntype,
    RecordLlmUsageRequestRuntype,
} from './llmUsageBackendTypes';

export const llmUsageEndpoints = {
    'POST /llm/usage': endpoint({
        description:
            'Internal: records a batch of rated LLM usage rows. Rows already recorded are skipped; answers 204.',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RecordLlmUsageRequestRuntype,
        responseBody: z.unknown(),
        base: 'internal',
    }),

    'POST /llm/usage/check': endpoint({
        description:
            "Internal: checks a tenant's month-to-date LLM spend, and optionally an app's, against their Caps.",
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CheckLlmCapsRequestRuntype,
        responseBody: CheckLlmCapsResponseRuntype,
        base: 'internal',
    }),
};
